import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import KibliLogo from "../components/KibliLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo procesar la solicitud.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-md flex flex-col items-center gap-6 animate-fade-in-up">
        <KibliLogo size={64} />
        {sent ? (
          <div className="w-full text-center space-y-4" data-testid="forgot-sent">
            <div className="inline-flex w-16 h-16 rounded-full bg-green-100 text-green-600 items-center justify-center mx-auto">
              <i className="fa-solid fa-envelope-circle-check text-2xl"></i>
            </div>
            <h1 className="text-2xl font-extrabold">Revisa tu correo</h1>
            <p className="text-slate-600">
              Si <span className="font-semibold">{email}</span> está registrado en KibliApp, te hemos enviado un enlace para restablecer tu contraseña.
              El enlace caduca en <span className="font-semibold">1 hora</span>.
            </p>
            <p className="text-sm text-slate-500">
              ¿No lo ves? Revisa tu carpeta de Spam o solicítalo de nuevo en unos minutos.
            </p>
            <Link to="/login" className="btn-primary inline-block px-6 py-3 mt-2" data-testid="back-to-login">
              Volver a inicio de sesión
            </Link>
          </div>
        ) : (
          <>
            <div className="text-center">
              <h1 className="text-2xl md:text-3xl font-extrabold">¿Olvidaste tu contraseña?</h1>
              <p className="text-slate-500 mt-1">Te enviaremos un enlace seguro a tu correo.</p>
            </div>
            <form onSubmit={onSubmit} className="w-full space-y-4">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@email.com"
                  data-testid="forgot-email-input"
                  className="input-base"
                  autoComplete="email"
                />
              </div>
              {error && (
                <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl p-3" data-testid="forgot-error">{error}</div>
              )}
              <button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="btn-primary w-full py-4">
                {loading ? "Enviando..." : "Enviar enlace"}
              </button>
            </form>
            <Link to="/login" className="text-blue-600 font-semibold text-sm" data-testid="back-to-login-link">
              <i className="fa-solid fa-arrow-left mr-1"></i> Volver al inicio de sesión
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
